import Vue from "vue";
import SvgIcon from "@/components/ui/SvgIcon.vue";
import BaseButton from "@/components/ui/BaseButton.vue";
import LoadingLayout from "@/components/ui/LoadingLayout.vue";
import Breadcrumbs from "@/components/application/Breadcrumbs.vue";

Vue.component("svg-icon", SvgIcon);
Vue.component("base-button", BaseButton);
Vue.component("breadcrumbs", Breadcrumbs);
Vue.component("loading-layout", LoadingLayout);
